import { TablesFormValues } from '@features/DynamicPackagesConfigurationWizard/types';

export function parseTablesDetailsForBasket({
  tablesDetails,
  parentBasketId,
}: {
  tablesDetails: TablesFormValues;
  parentBasketId?: number;
}) {
  if (!tablesDetails?.restaurants) return [];

  const flattenedDetails = {
    restaurants: (tablesDetails?.restaurants || []).flat(),
    notes: tablesDetails?.notes,
  };

  return flattenedDetails.restaurants.map((r) => ({
    type: 'tables',
    adults: r?.adults || 1,
    children: r?.children || 0,
    dynamic_package: 'child',
    package_basket_item_id: parentBasketId,
    ...(tablesDetails?.notes ? { note: tablesDetails.notes } : {}),
    ...(r?.celebrationOptions ? { celebrations: r.celebrationOptions } : {}),
    ...(r?.dietaryRequirements ? { dietaryRequirements: r.dietaryRequirements } : {}),
    bookable: {
      ids: {
        timeslot: r?.timeslot.timeSlot,
        restaurant: r?.restaurant.restaurantName,
        restaurant_name: r?.restaurant.configName,
        promotion_id: r?.promotion?.id,
        restaurant_config: r?.restaurant.id,
        timeslot_reservation_id:
          r?.promotion?.timeslotReservationId ?? r?.timeslot?.timeslotReservationId,
      },
    },
  }));
}
